import { makeVar } from '@apollo/client';
export const authVar = makeVar({
    loaded:false,
    authenticated:false
});